import { animationTransition } from './animationTransition';
import { styled } from '@withjoy/joykit';

/**
 * The visible mark is the <canvas> (solid-filled with `logoColor`) clipped by an
 * `objectBoundingBox` clipPath whose bounding box is the sibling <svg>. The two are sized
 * independently, so a consumer must override **both** together — size only the <svg> and the
 * clip region ends up wider than the painted canvas, leaving the mark cut off (CORE-6518).
 * `BurgerLogoTrigger` and `ShareYourStayBrandLogo` show the expected pattern.
 */
const JOY_LOGO_SVG_WIDTH = 88;
const JOY_LOGO_CANVAS_WIDTH = 40;

export const StyledJoyLogo = styled.a`
  position: relative;
  display: flex;
  transition: ${animationTransition('color', 'transform')};
  color: ${({ color }) => (color ? color : '')};

  & svg {
    width: ${JOY_LOGO_SVG_WIDTH}px;
    height: inherit;

    path.clip-path {
      width: unset;
      transform: scale(0.01075, 0.0155);
    }
  }

  :hover {
    // TODO: Make hover effect not clip on bottom border
    /* transform: scale(1.1); */
    color: ${({ color }) => (color ? color : '')};
  }
`;

export const StyledCanvasWrapper = styled.div<{ clipPathId: string }>`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  clip-path: url('#${props => props.clipPathId}');
`;

export const StyledCanvas = styled.canvas`
  width: ${JOY_LOGO_CANVAS_WIDTH}px;
  height: intrinsic;
`;
